// register app plugins
import Vue from 'vue';
import confirmationPlugin from './confirmationPlugin';

Vue.use(confirmationPlugin);
